const module = {
  config: {
    name: "stock-&-inventory",
    svg: "../static/img/icon/menu/stock.svg",
    desc: "Berisi modul stock inventory pada persemaian",
    layout: true
  },
  routes: [
    // Stock Inisiasi
    {
      name: "Stock Inisiasi",
      icon: "ri-database-line",
      path: "/stock-inisiasi",
      component: () => import("./stock-inisiasi.vue"),
      separator: "Stock In"
    },
    // Penerimaan Bibit
    {
      name: "Penerimaan Bibit",
      icon: "ri-database-fill",
      path: "/penerimaan-barang",
      component: () => import("./penerimaan-barang.vue"),
      separator: "Stock In"
    },
    // Penambahan
    {
      name: "Penambahan",
      icon: "ri-file-add-line",
      path: "/stock-adjusment-fase-increment",
      component: () => import("./stock-adjusment-fase/increment.vue"),
      separator: "Stock Movement Pada Bedeng"
    },
    // Pengurangan
    {
      name: "Pengurangan",
      icon: "ri-file-edit-line",
      path: "/stock-adjusment-fase-decrement",
      component: () => import("./stock-adjusment-fase/decrement.vue"),
      separator: "Stock Movement Pada Bedeng"
    },
    // Penugasan Audit
    {
      name: "Penugasan Audit",
      icon: "ri-user-shared-line",
      path: "/stock-adjusment-audit-assignment",
      component: () => import("./stock-adjusment-fase/audit-assignment.vue"),
      separator: "Stock Audit"
    },
    // Audit
    {
      name: "Audit",
      icon: "ri-survey-line",
      path: "/stock-adjusment-fase-audit",
      component: () => import("./stock-adjusment-fase/audit.vue"),
      separator: "Stock Audit"
    },
    // Penanaman
    {
      name: "Penanaman Awal",
      icon: "ri-bubble-chart-line",
      path: "/penanaman-awal",
      component: () => import("./inventory/penanaman-awal.vue"),
      separator: "History"
    },
    {
      name: "Stock Movement Pada Bedeng",
      icon: "ri-history-line",
      path: "/stock-adjusment-fase",
      component: () => import("./inventory/stock-adjusment-fase.vue"),
      separator: "History"
    },
    // Pra-Perlakuan Benih
    // {
    //   name: "Pra-Perlakuan Benih",
    //   icon: "ri-hand-coin-line",
    //   path: "/inventory-pra-perlakuan-benih",
    //   component: () => import("./inventory/pra-perlakuan-benih.vue"),
    //   separator: "Inventory (Realtime)"
    // },
    // Penanaman
    {
      name: "Penanaman",
      icon: "ri-bubble-chart-line",
      path: "/inventory-benih",
      component: () => import("./inventory/benih.vue"),
      separator: "Realtime"
    },
    // BBST
    {
      name: "BBST",
      icon: "ri-seedling-line",
      path: "/inventory-bbst",
      component: () => import("./inventory/bbst.vue"),
      separator: "Realtime"
    },
    // BST - Inventory
    {
      name: "BST - Inventory",
      icon: "ri-plant-line",
      path: "/inventory-inventory_bst",
      component: () => import("./inventory/inventory_bst.vue"),
      separator: "Realtime"
    },
    // Stock Akhir Tahun
    {
      name: "Stock Akhir Program",
      icon: "ri-stock-line",
      path: "/annual-stock",
      component: () => import("./annual-stock/annual-stock.vue"),
      separator: "Penutupan Stock"
    },
  ]
};
export default module;



// WEBPACK FOOTER //
// ./src/modules/stock-management/_index.js